export function transformMaterials ({ materials, sourceTenantId, targetTenantId, wfInstanceId }) {
  const materialsToInsert = []
  const materialsToDelete = []
  const pricingTierUpdates = []
  const pricingTierDelete = []
  const newPricingTiers = []
  const vendorMaterialUpdates = []

  if (!materials || materials?.length <= 0 || !wfInstanceId) {
    return {
      materialsToInsert,
      materialsToDelete,
      pricingTierUpdates,
      newPricingTiers,
      pricingTierDelete,
      vendorMaterialUpdates
    }
  }

  materials.forEach(material => {
    //  If entire material marked for delete
    if (material.flag === 'delete') {
      materialsToDelete.push(material.id)
      return
    }
    // 2️If NEW material → insert including tier pricing

    if (material.flag === 'new') {
      materialsToInsert.push({
        material_id: material.material_id,
        moq: Number(material.moq) || 1,
        lead_time: Number(material.lead_time) || 1,
        target_tenant_id: targetTenantId,
        vendor_materials_pricing_tiers: {
          data: material.tier_pricing
            .map(t => ({
              min_quantity: Number(t.min_qty),
              max_quantity: t.max_qty || null,
              unit_price: Number(t.unit_cost)
            }))

        }

      })
    }

    //  EXISTING MATERIAL → update tiers OR delete tiers OR insert new tiers

    if (material.flag === 'exist') {
      for (const pricingRow of material.tier_pricing) {
        // Insert new tiers
        if (pricingRow.flag === 'new') {
          newPricingTiers.push({
            vendor_material_id: material.id,
            min_quantity: Number(pricingRow.min_qty),
            max_quantity: pricingRow.max_qty || null,
            unit_price: Number(pricingRow.unit_cost)
          })
        } else if (pricingRow.flag === 'delete') {
          pricingTierDelete.push(pricingRow.id)
        } else if (pricingRow.flag === 'update') {
          pricingTierUpdates.push({
            where: { id: { _eq: pricingRow.id } },
            _set: {
              min_quantity: Number(pricingRow.min_qty),
              max_quantity: pricingRow.max_qty || null,
              unit_price: Number(pricingRow.unit_cost)
            }

          })
        }
      }
    }
    if (material.flag === 'update') {
      vendorMaterialUpdates.push({
        where: { id: { _eq: material.id } },
        _set: { lead_time: material.lead_time, moq: material.moq }
      })
      for (const pricingRow of material.tier_pricing) {
        // Insert new tiers
        if (pricingRow.flag === 'new') {
          newPricingTiers.push({
            vendor_material_id: material.id,
            min_quantity: Number(pricingRow.min_qty),
            max_quantity: pricingRow.max_qty || null,
            unit_price: Number(pricingRow.unit_cost)
          })
        } else if (pricingRow.flag === 'delete') {
          pricingTierDelete.push(pricingRow.id)
        } else if (pricingRow.flag === 'update') {
          pricingTierUpdates.push({
            where: { id: { _eq: pricingRow.id } },
            _set: {
              min_quantity: Number(pricingRow.min_qty),
              max_quantity: pricingRow.max_qty || null,
              unit_price: Number(pricingRow.unit_cost)
            }

          })
        }
      }
    }
  })
  return {
    materialsToInsert,
    materialsToDelete,
    pricingTierUpdates,
    newPricingTiers,
    pricingTierDelete,
    vendorMaterialUpdates
  }
}

export function formatedMaterialData (materialData) {
  const Data = []
  for (const material of materialData) {
    const obj = {
      id: material.id,
      material_id: material.material_id,
      custom_material_id: material.core_material_master.custom_material_id,
      material_name: material.core_material_master.material_name,
      moq: material.moq,
      lead_time: material.lead_time,
      flag: 'exist',
      tier_pricing: material.vendor_materials_pricing_tiers.map(item => ({
        id: item.id,
        min_qty: item.min_quantity,
        max_qty: item.max_quantity || null,
        unit_cost: item.unit_price,
        flag: 'exist'
      }))

    }
    Data.push(obj)
  }
  return Data
}
